/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ percent: NonNullable<unknown>, message: NonNullable<unknown> }} Import_Feed_ProgressInputs */

const cs_import_feed_progress = /** @type {(inputs: Import_Feed_ProgressInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.percent}% — ${i?.message}`)
};

const en_import_feed_progress = /** @type {(inputs: Import_Feed_ProgressInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.percent}% — ${i?.message}`)
};

/**
* | output |
* | --- |
* | "{percent}% — {message}" |
*
* @param {Import_Feed_ProgressInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const import_feed_progress = /** @type {((inputs: Import_Feed_ProgressInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_Feed_ProgressInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_import_feed_progress(inputs)
	return cs_import_feed_progress(inputs)
});